import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-300 mx-1" aria-hidden="true">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {!isLast && item.path ? (
                <Link
                  to={item.path}
                  className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`whitespace-nowrap ${
                    isLast ? 'text-foreground-700 font-medium' : ''
                  }`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}